export default __webpack_public_path__ + "static/media/element3Card.93348ad5.svg";